import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { SearchResult } from "@/types/search";

/** Minimum query length before we hit the server (mirrors the backend guard). */
export const MIN_SEARCH_LEN = 2;

/**
 * Global keyword search across customers, deals, and contacts. `query` should
 * already be debounced by the caller; the hook trims it and only fires at or
 * above {@link MIN_SEARCH_LEN}. `keepPreviousData` keeps the last results
 * on screen while the next query is in flight, so the dropdown doesn't flicker.
 */
export function useSearch(query: string) {
  const q = query.trim();
  return useQuery({
    queryKey: ["search", q],
    queryFn: () => api.get<SearchResult[]>(`/api/search?q=${encodeURIComponent(q)}`),
    enabled: q.length >= MIN_SEARCH_LEN,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
